const colors = {
  //** 컬러 네이밍 규칙 */
  //** 키값을 걍 #떼고 C붙인다 */ 
  CF7F7F7: `#F7F7F7`,
  C000000: `#000000`,
  CFFFFFF: `#FFFFFF`,
  C474747: `#474747`,
  CB5B5B5: `#B5B5B5`,
  C41F0CD: `#41F0CD`,
  C46B19C: `#46B19C`,
  CCCCCCC: `#CCCCCC`,
  CECECEC: `#ECECEC`,
  C2E303C: `#2E303C`,
  C494A53: `#494A53`,
  CE03E31: `#E03E31`,
  CC12C20: `#C12C20`,
  C3C3C3C: `#3C3C3C`,
  C5759D0: `#5759D0`,
  C3335AD: `#3335AD`,
  C00000038: `#00000038`,
  C00000033: `#00000033`,
  CE8E8E8: `#E8E8E8`,
  C2CBFA3CC:`#2CBFA3CC`,
  CE03E31CC: `#E03E31CC`,
  C2F2F2F: `#2F2F2F`,
  C555555: `#555555`,
  C2C2C2C: `#2C2C2C`,
}

export default colors;